/* Use the first body image when a post has no Ghost Feature image. */
(function () {
    const cardSelector = '[data-card-image-fallback]';

    function copyAttribute(source, target, name) {
        const value = source.getAttribute(name);

        if (value) {
            target.setAttribute(name, value);
        }
    }

    function hydrateCardImageFallbacks(scope) {
        const root = scope || document;
        const containers = root.matches && root.matches(cardSelector)
            ? [root]
            : root.querySelectorAll(cardSelector);

        containers.forEach(function (container) {
            const template = container.querySelector('[data-card-image-source]');
            const firstImage = template && template.content.querySelector('img[src], img[data-src]');
            const card = container.closest('.gh-card');

            if (!firstImage) {
                container.remove();
                return;
            }

            const image = document.createElement('img');
            const source = firstImage.getAttribute('src') || firstImage.getAttribute('data-src');

            image.src = source;
            image.alt = firstImage.alt || '';
            copyAttribute(firstImage, image, 'srcset');
            copyAttribute(firstImage, image, 'sizes');
            image.loading = 'lazy';

            template.remove();
            container.appendChild(image);
            card.classList.remove('no-image');
        });
    }

    window.sourceHydrateCardImageFallbacks = hydrateCardImageFallbacks;
    hydrateCardImageFallbacks(document);

    document.addEventListener('source:cards-added', function (event) {
        event.detail.cards.forEach(hydrateCardImageFallbacks);
    });
})();
